import Image from 'next/legacy/image'

import React from 'react'

import genericIcon from '@/assets/file-icons/generic-svgrepo-com.svg'
import imageIcon from '@/assets/file-icons/jpg-svgrepo-com.svg'
import pdfIcon from '@/assets/file-icons/pdf-svgrepo-com.svg'
import pptIcon from '@/assets/file-icons/ppt-svgrepo-com.svg'
import wordIcon from '@/assets/file-icons/txt-svgrepo-com.svg'
import excelIcon from '@/assets/file-icons/xls-svgrepo-com.svg'

export function DownloadFile({ document }) {
  const lookup = {
    pdf: pdfIcon,
    xls: excelIcon,
    xlsx: excelIcon,
    png: imageIcon,
    jpg: imageIcon,
    jpeg: imageIcon,
    word: wordIcon,
    ppt: pptIcon,
    // Add more file types here...
  }

  const fileExt = document?.original_filename?.split('.').pop().toLowerCase()

  return (
    <a
      href={document?.download_url}
      target='_blank'
      rel='noopener noreferrer'
      className='inline-flex items-center px-5 py-3 rounded bg-white shadow hover:bg-gray-50 cursor-pointer'
    >
      <Image
        src={lookup[fileExt] || genericIcon}
        alt='Download Attachment'
        height={48}
        width={48}
      />
      <div className='hover:underline'>{document?.original_filename}</div>
    </a>
  )
}
